export default () => {
  const halloween = useHalloweenStore();
  const { t } = useI18n();
  const { isMobile } = useDevice();

  const expeditionEndDate = computed(() => {
    return (
      halloween.$state.statefulUserExpeditions.map((e) => e.endsAt).sort((a, b) => b.getTime() - a.getTime())?.[0] ||
      new Date()
    );
  });

  const { timeLeft } = useCountdownDate(expeditionEndDate, 'second');

  return computed(() => {
    if (halloween.$state.statefulUserExpeditions.length === 0) return isMobile ? '' : t('buildingExpeditionDistrict');

    const { hours, minutes, seconds } = timeLeft;

    if (hours) {
      return `${t('coreHoursMin', { hours: hours, minutes: minutes })}`;
    }

    if (minutes) {
      return `${t('coreMin', { value: minutes })} ${t('coreSec', { value: seconds })}`;
    }

    if (seconds) {
      return `${t('coreSec', { value: seconds })}`;
    }

    if (isMobile) return '';

    return t('buildingExpeditionDistrict');
  });
};
